export const offersES = {
    shippingTitle: "ENVÍO GRATIS",
    shippingText1: "Para pedidos de más de ",
    shippingText2: "€ envío gratuito",
    cashTitle: "PAGO CONTRA REEMBOLSO",
    cashText: "Pago contra reembolso sin cargo adicional",
    topSellers: "Más vendidos"
}